import { Map,Record } from "immutable";

import createFromJS from "../../createFromJS";

export const StandardTimelineRecord = Record({
  definition: Map(),
  data: Map(),
  applicableDate: null,
  language: null,
  "@context": null,
  appData: null
});

const data = {
  objects: {
    appData: "Map"
  },
  collections: {
    definition: "StandardDefinitionRecord",
    data: "StandardDataRecord"
  }
};
createFromJS.registerCallback(
  "StandardTimelineRecord",
  createFromJS.createNestedCallback(StandardTimelineRecord, data)
);
